export default __webpack_public_path__ + "static/media/GR00004-stamp.16fab41a.svg";